import { ViteSSG } from 'vite-ssg';
import type { Component } from 'vue';
import i18n from './i18n';
import App from './App.vue';
import { routes } from './router';
import './assets/main.css';

export const createApp = ViteSSG(
    App as Component,
    {
        routes,
        scrollBehavior(to, _from, savedPosition) {
            if (savedPosition) {
                return savedPosition;
            }
            if (to.hash) {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        const element = document.querySelector(to.hash);
                        if (element) {
                            const headerOffset = 80;
                            const top = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                            resolve({ top, behavior: 'smooth' });
                        } else {
                            resolve({ top: 0 });
                        }
                    }, 100);
                });
            }
            return { top: 0 };
        }
    },
    ({ app }) => {
        // vite-ssg provides head automatically via @unhead/vue
        app.use(i18n);
    }
);
